// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Pervasives from "../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_format from "../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as Caml_js_exceptions from "../../../../node_modules/rescript/lib/es6/caml_js_exceptions.js";
import * as IconCheck$Showside from "../icons/IconCheck.bs.js";
import * as InitialFocus$Showside from "../utils/InitialFocus.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as DynamicTruncate$Showside from "./DynamicTruncate.bs.js";
function FiltersField$NumberInput(Props) {
  var value = Props.value;
  var min = Props.min;
  var max = Props.max;
  var placeholderOpt = Props.placeholder;
  var prefix = Props.prefix;
  var classNameOpt = Props.className;
  var onChange = Props.onChange;
  var placeholder = placeholderOpt !== undefined ? placeholderOpt : "";
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var fromString = function (value$1) {
    try {
      return Caml_format.float_of_string(value$1 === "" ? "0" : value$1);
    } catch (raw__msg) {
      var _msg = Caml_js_exceptions.internalToOCamlException(raw__msg);
      if (_msg.RE_EXN_ID === "Failure") {
        return value;
      }
      throw _msg;
    }
  };
  var match = React.useState(function () {
    return fromString("");
  });
  var setValue = match[1];
  var value$1 = match[0];
  var match$1 = React.useState(function () {
    return false;
  });
  var setFocused = match$1[1];
  var inputRef = React.useRef(null);
  React.useEffect(function () {
    Curry._1(setValue, function (param) {
      return value;
    });
  }, [value]);
  var onFocus = function (param) {
    Curry._1(setFocused, function (param) {
      return true;
    });
  };
  var onBlur = function (param) {
    var value$2 = max !== undefined ? min !== undefined ? Math.max(Math.min(value$1, max), min) : Math.min(value$1, max) : min !== undefined ? Math.max(value$1, min) : value$1;
    Curry._1(setFocused, function (param) {
      return false;
    });
    Curry._1(setValue, function (param) {
      return value$2;
    });
    Curry._1(onChange, value$2);
  };
  var onSubmit = function (e) {
    e.preventDefault();
    Belt_Option.forEach(Caml_option.nullable_to_opt(inputRef.current), function (el) {
      el.blur();
    });
  };
  var onInput = function (e) {
    var value = e.target.value;
    Curry._1(setValue, function (param) {
      return fromString(value);
    });
  };
  var handleFocusInput = function (param) {
    Belt_Option.forEach(Caml_option.nullable_to_opt(inputRef.current), function (el) {
      el.focus({
        preventScroll: true
      });
    });
  };
  return React.createElement("div", {
    className: Cn.make([className, CSS$Showside.prefix("relative"), CSS$Showside.prefix("rounded-custom ring-accent ring-0 ring-inset focus-within:ring-1"), CSS$Showside.prefix("cursor-text")]),
    onClick: handleFocusInput
  }, React.createElement("div", {
    className: CSS$Showside.prefix("flex w-full")
  }, Belt_Option.mapWithDefault(prefix, null, function (prefix) {
    return React.createElement("span", {
      className: CSS$Showside.prefix("flex opacity-50 items-center justify-center space-x-2 text-base font-medium text-primary p-2 cursor-text")
    }, prefix);
  }), React.createElement("div", {
    className: CSS$Showside.prefix("flex-grow")
  }, React.createElement("form", {
    onSubmit: onSubmit
  }, React.createElement("input", {
    ref: ReactDOMUtils$Showside.Ref.domRef(inputRef),
    className: CSS$Showside.prefix("border-none w-full h-full outline-none text-lg bg-transparent"),
    placeholder: placeholder,
    type: "number",
    value: String(value$1),
    onFocus: onFocus,
    onBlur: onBlur,
    onInput: onInput
  })))), match$1[0] ? null : React.createElement("span", {
    className: CSS$Showside.prefix("absolute inset-0 bg-main space-x-2 text-base font-medium text-primary p-2 cursor-text")
  }, Belt_Option.mapWithDefault(prefix, null, function (prim) {
    return prim;
  }), " ", value$1));
}
FiltersField$NumberInput.displayName = "FiltersField.NumberInput";
var NumberInput = {
  make: FiltersField$NumberInput
};
function FiltersField$Checkbox(Props) {
  var indexOpt = Props.index;
  var value = Props.value;
  var labelOpt = Props.label;
  var countOpt = Props.count;
  var styleOpt = Props.style;
  var swatch = Props.swatch;
  var isRadioOpt = Props.isRadio;
  var isGridOpt = Props.isGrid;
  var onCheckedOpt = Props.onChecked;
  var onUncheckedOpt = Props.onUnchecked;
  var onFocusOpt = Props.onFocus;
  var customIcon = Props.customIcon;
  var disabledOpt = Props.disabled;
  var highlightOpt = Props.highlight;
  var rtlOpt = Props.rtl;
  var autoFocusOpt = Props.autoFocus;
  var largeOpt = Props.large;
  var sectionIdPrefixOpt = Props.sectionIdPrefix;
  var index = indexOpt !== undefined ? indexOpt : 0;
  var label = labelOpt !== undefined ? labelOpt : "";
  var count = countOpt !== undefined ? countOpt : 0;
  var style = styleOpt !== undefined ? styleOpt : /* Checkbox */1;
  var isRadio = isRadioOpt !== undefined ? isRadioOpt : false;
  var isGrid = isGridOpt !== undefined ? isGridOpt : false;
  var onChecked = onCheckedOpt !== undefined ? onCheckedOpt : function (i) {};
  var onUnchecked = onUncheckedOpt !== undefined ? onUncheckedOpt : function (i) {};
  var onFocus = onFocusOpt !== undefined ? onFocusOpt : function (i) {};
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var highlight = highlightOpt !== undefined ? highlightOpt : false;
  var rtl = rtlOpt !== undefined ? rtlOpt : false;
  var autoFocus = autoFocusOpt !== undefined ? autoFocusOpt : false;
  var large = largeOpt !== undefined ? largeOpt : false;
  var sectionIdPrefix = sectionIdPrefixOpt !== undefined ? sectionIdPrefixOpt : "filters";
  var bg = value ? "bg-accent text-main" : "bg-transparent hover:text-primary text-secondary";
  var isButton = style === /* ButtonCheckbox */3;
  var isSwatch = (style === /* ColorCheckbox */0 || style === /* ImageCheckbox */2) && Belt_Option.isSome(swatch);
  var interactivity = disabled ? "pointer-events-none opacity-25" : "cursor-pointer";
  var border = value ? isSwatch ? "ring-2 ring-current text-accent" : "border border-solid border-accent" : "border border-solid hover:border-primary border-secondary";
  var renderSwatchBackground = function (param) {
    var className = CSS$Showside.prefix("absolute inset-0");
    var bg;
    if (style >= 3) {
      bg = null;
    } else {
      switch (style) {
        case /* ColorCheckbox */0:
          bg = swatch !== undefined ? React.createElement("div", {
            className: className,
            style: {
              background: swatch
            }
          }) : null;
          break;
        case /* Checkbox */1:
          bg = null;
          break;
        case /* ImageCheckbox */2:
          bg = swatch !== undefined ? React.createElement("div", {
            className: className
          }, React.createElement(SmartImg$Showside.make, {
            src: swatch,
            fit: /* Contain */2,
            alt: label,
            priority: 1
          })) : null;
          break;
      }
    }
    return React.createElement(React.Fragment, undefined, bg, value ? React.createElement("div", {
      className: CSS$Showside.prefix("flex w-full h-full items-center justify-center")
    }, React.createElement(IconCheck$Showside.make, {
      className: CSS$Showside.prefix(Cn.make(["text-white", "drop-shadow-dark filter"])),
      strokeWidth: "3"
    })) : null);
  };
  var fill;
  switch (style) {
    case /* Checkbox */1:
      fill = value ? React.createElement(IconCheck$Showside.make, {
        className: CSS$Showside.prefix("text-main w-7 h-7 absolute inset-0 transform scale-50 -translate-y-px -translate-x-px"),
        strokeWidth: "3"
      }) : null;
      break;
    case /* ColorCheckbox */0:
    case /* ImageCheckbox */2:
      fill = renderSwatchBackground(undefined);
      break;
    case /* ButtonCheckbox */3:
    case /* Range */4:
      fill = null;
      break;
    case /* Radio */5:
      fill = React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["absolute inset-0 bg-main m-1 rounded-full transform transition-transform duration-75", value ? "scale-70" : "scale-0"]))
      });
      break;
  }
  var rounded;
  switch (style) {
    case /* Checkbox */1:
    case /* ButtonCheckbox */3:
    case /* Range */4:
      rounded = "rounded-custom";
      break;
    case /* ColorCheckbox */0:
    case /* ImageCheckbox */2:
    case /* Radio */5:
      rounded = "rounded-full";
      break;
  }
  var textAlign = style !== 1 && style < 4 ? "text-center" : "";
  var labelContainerWidth = style !== 1 && style < 3 ? "w-full px-2" : "";
  var padding = style !== 3 ? large ? "p-4" : "py-2" : large ? "py-4 px-6" : "py-3 px-4";
  var icon;
  var exit = 0;
  if (customIcon !== undefined) {
    icon = Caml_option.valFromOption(customIcon);
  } else {
    switch (style) {
      case /* ColorCheckbox */0:
      case /* ImageCheckbox */2:
        exit = 2;
        break;
      case /* ButtonCheckbox */3:
        icon = null;
        break;
      case /* Checkbox */1:
      case /* Range */4:
      case /* Radio */5:
        exit = 1;
        break;
    }
  }
  switch (exit) {
    case 1:
      icon = React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["w-7 h-7 relative flex-shrink-0", "overflow-hidden", border, rounded, bg]))
      }, fill);
      break;
    case 2:
      icon = React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["w-10 h-10 relative flex-shrink-0", "overflow-hidden", border, rounded, bg]))
      }, fill);
      break;
  }
  var tooltipText = style !== 1 && style < 3 ? "" + label + " have " + String(count) + " products" : undefined;
  var countElement = count !== 0 && style !== /* ImageCheckbox */2 && style !== /* ColorCheckbox */0 ? React.createElement("div", {
    className: CSS$Showside.prefix("opacity-50 inline")
  }, " (" + String(count) + ")") : null;
  var labelElement = React.createElement(React.Fragment, undefined, label, countElement);
  var onClick = function (param) {
    if (!disabled) {
      if (!value || isRadio) {
        return Curry._1(onChecked, index);
      } else {
        return Curry._1(onUnchecked, index);
      }
    }
  };
  var ref = React.useRef(null);
  var domRef = autoFocus ? Caml_option.some(ReactDOMUtils$Showside.Ref.domRef(ref)) : undefined;
  InitialFocus$Showside.use(Pervasives.string_of_bool(autoFocus), ref);
  var onFocus$1 = function (param) {
    Curry._1(onFocus, index);
  };
  var tmp = {
    className: CSS$Showside.prefix(Cn.make(["flex items-center no-touch-highlight relative", "group-3", isGrid && isSwatch ? "mb-4" : isGrid ? "mb-4 mr-4" : "", isSwatch ? "flex-col" : rtl ? "flex-row-reverse space-x-reverse" : "", isButton ? border : "", isButton ? rounded : "", isButton ? bg : "hover:text-primary text-secondary", padding, interactivity])),
    role: style >= 5 ? "menuitemradio" : "menuitemcheckbox",
    tabIndex: 0,
    onFocus: onFocus$1,
    onClick: onClick
  };
  if (domRef !== undefined) {
    tmp.ref = Caml_option.valFromOption(domRef);
  }
  if (tooltipText !== undefined) {
    tmp.title = Caml_option.valFromOption(tooltipText);
  }
  return React.createElement(DataAttribute$Showside.make, {
    dataDisabled: disabled,
    dataActive: value,
    dataTestId: "filters-option",
    dataId: "" + sectionIdPrefix + "-" + label + "",
    ariaChecked: value,
    children: React.createElement("div", tmp, highlight && !isButton ? React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["absolute -left-6 -right-6 top-0 bottom-0 pointer-events-none", value ? "opacity-10 bg-accent" : "group-3-hover:bg-primary opacity-5"]))
    }) : null, icon, React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["relative", "flex-grow text-lg", isSwatch ? "mt-3" : rtl ? "" : "ml-3", textAlign, labelContainerWidth, "font-button"]))
    }, style === 4 || style === 3 ? labelElement : React.createElement(DynamicTruncate$Showside.make, {
      lines: 2,
      children: labelElement
    })))
  });
}
FiltersField$Checkbox.displayName = "FiltersField.Checkbox";
var Checkbox = {
  make: FiltersField$Checkbox
};
export { NumberInput, Checkbox };
/* react Not a pure module */